import React from 'react';

const Manage = () => {
    return (
        <div style={{ padding: '30px' }}>
            <h3>Manage</h3>
            <p>This page is under construction.</p>
        </div>
    );
};

export default Manage;
